export default __webpack_public_path__ + "static/media/cream-wave-3.e96db017.svg";